export default {
  authenticated(state) {
    return state.data.accessToken && state.data.refreshToken
  },

  accessToken(state) {
    return state.data.accessToken
  },

  refreshToken(state) {
    return state.data.refreshToken
  }
  
}



// WEBPACK FOOTER //
// ./src/store/modules/token/getters.js